import React from "react";
import { withStyles } from '@material-ui/core';
import ContentBody from "./ContentBody"
import publicImage from "images/public.png"
import PersonSingle from "images/PersonSingle.png"
import Save from "images/save.png"
import { Earth } from "icons";

console.log("Earth", Earth)

const styles = () => ({
  root: {
    border: "1px solid #dadada",
    borderRadius: 10,
    padding: "12px 15px"
  },
  profileStyle: {
    width: 38,
    height: 38,
    borderRadius: 19,
    background: "#E4E6EA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 9,
    fontWeight: "bold"
  },
  displayFlex: {
    display: "flex",
    alignItems: "center",
  },
  userName: {
    fontSize: 15,
    fontWeight: "bold"
  },
  marginStyle: {
    marginBottom: 12
  },
  displayTwitterStyle: {
    display: "flex",
    alignItems: "end"
  },
  marginTopStyle: {
    marginTop: 12
  },
  tagTextStyle: {
    color: "#868b9f",
    marginLeft: 10,
    marginRight: 30
  },
  bottomTagColor: {
    color: "#26bbed",
    fontWeight: "bold"
  },
  container: {
    width: "100%"
  }
})


const BottomTag = ({ image, classes, text }) => {
  return (
    <div className={`${classes.displayFlex} ${classes.marginTopStyle}`}>
      <img height="20px" width="20px" src={image} />
      <div className={classes.tagTextStyle}>{text}</div>
    </div>
  )
}

const ProfileContainer = ({ classes, content, type }) => {
  return (
    <div className={`${classes.displayFlex} ${classes.marginStyle}`}>
      <div className={classes.profileStyle}>
        {content}
      </div>
      {
        type === "facebook" ?
          <div className={classes.userName}>
            UserName<br />
            <img width="80" alt="fb" src={publicImage} />
          </div> : null
      }
    </div>
  )
}

const PopupBody = ({ classes, showNotification, values, type, handleChange }) => {
  return (
    <div className={`${classes.root} ${type === "twitter" && classes.displayTwitterStyle}`}>
      <ProfileContainer type={type} classes={classes} content={type === "twitter" ? "R" : "U"} />
      <div className={classes.container}>
        <ContentBody type={type} values={values} showNotification={showNotification} handleChange={handleChange} />
        {
          type == "twitter" &&
          <>
            <div className={classes.displayFlex}>
              <BottomTag classes={classes} image={PersonSingle} text="Tag people" />
              <BottomTag classes={classes} image={Save} text="Add description" />
            </div>
            <div className={`${classes.displayFlex} ${classes.marginTopStyle}`}>
              <Earth />
              <div className={`${classes.tagTextStyle} ${classes.bottomTagColor}`} >Everyone can reply</div>
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default withStyles(styles)(PopupBody);